export const TICKET_STATUS = {
  OPEN: ["Offen", "bg-blue-100 text-blue-700"],
  IN_PROGRESS: ["In Bearbeitung", "bg-amber-100 text-amber-700"],
  WAITING_CUSTOMER: ["Wartet auf Kunde", "bg-purple-100 text-purple-700"],
  RESOLVED: ["Erledigt", "bg-green-100 text-green-700"],
  UNFOUNDED: ["Unbegründet", "bg-gray-100 text-gray-600"],
};
export const PRIO = {
  LOW: ["Niedrig", "bg-gray-100 text-gray-600"],
  NORMAL: ["Normal", "bg-secondary text-foreground/70"],
  HIGH: ["Hoch", "bg-orange-100 text-orange-700"],
  URGENT: ["Dringend", "bg-red-100 text-red-700"],
};
export const EMAIL_STATUS = {
  OPEN: ["Offen", "bg-blue-100 text-blue-700"],
  IN_PROGRESS: ["In Bearbeitung", "bg-amber-100 text-amber-700"],
  WAITING: ["Wartet auf Kunde", "bg-purple-100 text-purple-700"],
  DONE: ["Erledigt", "bg-green-100 text-green-700"],
};
export const ROLE_LABEL = { SUPPORT: "Support", MODERATOR: "Moderator", ADMIN: "Admin", SUPER_ADMIN: "Super-Admin" };

export const Badge = ({ map, value }) => {
  const [label, cls] = map[value] || [value, "bg-secondary text-foreground/70"];
  return <span className={`inline-block text-[11px] font-bold px-2 py-0.5 rounded-full whitespace-nowrap ${cls}`}>{label}</span>;
};

export const SlaDot = ({ sla }) => {
  if (!sla) return <span className="inline-block w-2.5 h-2.5 rounded-full bg-gray-200" title="Keine Frist aktiv" />;
  const cfg = {
    OK: ["bg-green-500", "Im Rahmen"],
    WARN: ["bg-amber-500", "Antwort bald fällig"],
    OVERDUE: ["bg-red-500 animate-pulse", "Überfällig"],
  }[sla.state];
  return (
    <span className="inline-flex items-center gap-1.5 whitespace-nowrap" title={`${cfg[1]} – seit ${Math.round(sla.hours)} Std. ohne Antwort (rot ab ${sla.overdue_at} Std.)`}>
      <span className={`inline-block w-2.5 h-2.5 rounded-full ${cfg[0]}`} />
      <span className={`text-[11px] font-bold ${sla.state === "OVERDUE" ? "text-red-600" : sla.state === "WARN" ? "text-amber-600" : "text-muted-foreground"}`}>
        {sla.hours < 1 ? "<1 Std." : `${Math.round(sla.hours)} Std.`}
      </span>
    </span>
  );
};

export const TemplateSelect = ({ templates, onPick }) => {
  if (!templates?.length) return null;
  const groups = {};
  templates.forEach((t) => {
    const g = t.name.includes("–") ? t.name.split("–")[0].trim() : "Weitere";
    (groups[g] = groups[g] || []).push(t);
  });
  return (
    <select data-testid="template-select" value=""
      className="text-xs font-semibold border border-border rounded-full pl-3 pr-7 py-2 bg-secondary/60 hover:border-accent/50 cursor-pointer max-w-[240px] truncate"
      onChange={(e) => { const t = templates.find((x) => x.id === e.target.value); if (t) onPick(t); e.target.value = ""; }}>
      <option value="">Vorlage einfügen…</option>
      {Object.entries(groups).map(([g, items]) => (
        <optgroup key={g} label={g}>
          {items.map((t) => <option key={t.id} value={t.id}>{t.name.includes("–") ? t.name.split("–").slice(1).join("–").trim() : t.name}</option>)}
        </optgroup>
      ))}
    </select>
  );
};

export function timeAgo(iso) {
  if (!iso) return "";
  const s = (Date.now() - new Date(iso).getTime()) / 1000;
  if (s < 60) return "gerade eben";
  if (s < 3600) return `vor ${Math.floor(s / 60)} Min.`;
  if (s < 86400) return `vor ${Math.floor(s / 3600)} Std.`;
  return `vor ${Math.floor(s / 86400)} Tagen`;
}

export function fmtDateTime(iso) {
  if (!iso) return "—";
  return new Date(iso).toLocaleString("de-DE", { day: "2-digit", month: "2-digit", year: "2-digit", hour: "2-digit", minute: "2-digit" });
}

export const card = "bg-white border border-border rounded-2xl";
export const inputCls = "w-full rounded-xl border border-border bg-white px-3.5 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-accent/50";
export const btnPrimary = "bg-accent text-white text-sm font-bold px-5 py-2.5 rounded-full hover:opacity-90 disabled:opacity-50";
export const btnGhost = "border border-border bg-white text-sm font-semibold px-4 py-2 rounded-full hover:bg-secondary/60";
